export default __webpack_public_path__ + "static/media/icon_hsc.48672d2b.svg";